import { RailwayTour } from '@ve/types/railway/RailwayTour';
import { HotelOffer } from '@ve/types/api/HotelOffer';
import Backbone from 'backbone';

type Product = RailwayTour | HotelOffer;
type RawProduct = HotelOffer | RailwayTour;

const productCompareKey = (product: Backbone.Model<Product>): string => `${product.get('id')}_${product.get('price')}`;
const rawProductCompareKey = (product: RawProduct): string => `${product.id}_${product.price}`;

export {
    productCompareKey,
    rawProductCompareKey,
};